import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * Accessible breadcrumb navigation. items: [{name, path}] (last item is current).
 */
export default function Breadcrumbs({ items = [], className = "" }) {
  if (!items.length) return null;
  return (
    <nav aria-label="Breadcrumb" className={className} data-testid="breadcrumbs">
      <ol className="flex flex-wrap items-center gap-2 text-sm">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={item.path} className="flex items-center gap-2">
              {isLast ? (
                <span aria-current="page" className="text-brand-cream/70">
                  {item.name}
                </span>
              ) : (
                <Link to={item.path} className="text-brand-gold hover:text-brand-gold-light transition-colors">
                  {item.name}
                </Link>
              )}
              {!isLast && <ChevronRight size={14} className="text-brand-cream/40" aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
